import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { useLangStore } from '../stores/langStore'
import { t } from '../i18n'
import { useState } from 'react'

export default function Navbar() {
  const { user, logout } = useAuthStore()
  const { lang, setLang } = useLangStore()
  const navigate = useNavigate()
  const location = useLocation()
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  const navLink = (to: string, label: string) => (
    <Link
      to={to}
      className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
        location.pathname === to
          ? 'bg-primary-100 text-primary-700'
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
      }`}
      onClick={() => setMobileOpen(false)}
    >
      {label}
    </Link>
  )

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">LE</span>
              </div>
              <span className="font-bold text-lg text-gray-900 hidden sm:block">HKSI Exam</span>
            </Link>
            {user && (
              <div className="hidden md:flex ml-8 space-x-1">
                {navLink('/', t('nav.home', lang))}
                {navLink('/practice', t('nav.practice', lang))}
                {navLink('/history', t('nav.history', lang))}
                {navLink('/bookmarks', t('nav.bookmarks', lang))}
                {navLink('/wrong-questions', t('nav.wrongQuestions', lang))}
                {navLink('/readiness', lang === 'zh' ? '準備度' : 'Readiness')}
                {user.role === 'admin' && navLink('/admin', t('nav.admin', lang))}
              </div>
            )}
          </div>

          <div className="flex items-center space-x-3">
            {/* Language selector */}
            <select
              value={lang}
              onChange={(e) => setLang(e.target.value as any)}
              className="text-sm border border-gray-300 rounded-md px-2 py-1 bg-white"
            >
              <option value="en">EN</option>
              <option value="zh">中文</option>
              <option value="bilingual">雙語</option>
            </select>

            {user ? (
              <div className="flex items-center space-x-3">
                <span className="text-sm text-gray-600 hidden sm:block">
                  {user.displayName || user.email}
                </span>
                <button onClick={handleLogout} className="btn-secondary btn-sm">
                  {t('nav.logout', lang)}
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <Link to="/login" className="btn-secondary btn-sm">{t('nav.login', lang)}</Link>
                <Link to="/register" className="btn-primary btn-sm">{t('nav.register', lang)}</Link>
              </div>
            )}

            {/* Mobile menu button */}
            {user && (
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="md:hidden p-2 rounded-md text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {mobileOpen
                    ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  }
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && user && (
          <div className="md:hidden pb-3 space-y-1 flex flex-col">
            {navLink('/', t('nav.home', lang))}
            {navLink('/practice', t('nav.practice', lang))}
            {navLink('/history', t('nav.history', lang))}
            {navLink('/bookmarks', t('nav.bookmarks', lang))}
            {navLink('/wrong-questions', t('nav.wrongQuestions', lang))}
            {navLink('/readiness', lang === 'zh' ? '準備度' : 'Readiness')}
            {user.role === 'admin' && navLink('/admin', t('nav.admin', lang))}
          </div>
        )}
      </div>
    </nav>
  )
}
